import React from 'react';
import { Input, Row, Col } from 'antd';

const ProcessesSearch = ({ processesData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    setSearchText(value);

    const normalizedValue = value.toLowerCase();
    const filtered = processesData.filter((record) => {
      const matchesCode = record.code?.toLowerCase().includes(value.toLowerCase());
      const matchesName = record.name?.toLowerCase().includes(value.toLowerCase());
      const matchesProcess = record.asset?.name?.toLowerCase().includes(normalizedValue);
      const matchesCategory = record.asset?.category?.name?.toLowerCase().includes(normalizedValue);
      const matchesArea = record.asset?.area?.name?.toLowerCase().includes(normalizedValue);
      const matchesDescription = record.description?.toLowerCase().includes(normalizedValue);
      const typeName = typeof record.type === "string" ? record.type : record.type?.name;
      const matchesType = typeName?.toLowerCase().includes(normalizedValue);

      return matchesCode || matchesName || matchesProcess || matchesCategory || matchesArea || matchesDescription || matchesType;
    });

    setFilteredData(filtered); 
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Procesos"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default ProcessesSearch;
